

export default {
  enums: [
    { id: 'SHIPMENT' },
    { id: 'ACCEPTANCE' },
  ]
};